const projectType = [
    {
        label: '工程',
        value: 0,
    },
    {
        label: '货物',
        value: 1,
    },
    {
        label: '服务',
        value: 2,
    },
    // {
    //     label: '国际货物',
    //     value: 3,
    // },
]

const getProjectTypeName = function (key) {
    const exist = projectType.find((t) => t.value === key)
    return exist ? exist.label : ''
}

module.exports = {
    projectType,
    getProjectTypeName,
}
